module.exports = "data:image/webp;base64,UklGRkYAAABXRUJQVlA4IDoAAAAwAwCdASoZABkAPpFCnEolo6KhqAgAsBIJYwB2AACAl+AAAP7qhKP+Cepco//hyp9O3VTiGc4Q8gAA"


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/wine-ws.webp
// module id = dikC
// module chunks = 14